export const cartRouter = {
    name: 'cart',
    component: () => import(/* webpackChunkName: "cart" */ '@/modules/cart/pages/CartPage'),
}
